import { Component, Input, OnInit } from '@angular/core';
import { Yii } from "../../../../interfaces/Yii";
import { CarModel } from "../../../../models/car/car.model";
import { capitalizeFirstLetter } from "../../../../service/utils/utils.service";
import {
    faHourglassEnd,
    faMapMarkerAlt,
    faPhone,
    faSearchLocation,
    IconDefinition
} from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-regular-svg-icons";

interface IPickCarContact {
    place?: string;
    address?: string;
    hoursOfOperationsSimplified: string[];
    hoursOfOperations: string[];
    phones: string[];
}

class WordingClass {
    public readonly hoursOfOperation: string = Yii.t('wui-shared-js', 'Horaire d\'ouverture');
    public readonly hoursOfOperationDetail: string = Yii.t('wui-shared-js', 'Voir le détail des horaires d\'ouverture');
    public readonly phone: string = Yii.t('wui-shared-js', 'Téléphone');
    public readonly address: string = Yii.t('wui-shared-js', 'Adresse');
}

@Component({
    selector: 'pick-car-contact',
    template: `
        <div class="first" *ngIf="showPlace">
            <div class="title">
                <fa-icon *ngIf="isShowIcon" [icon]="iconLocation"></fa-icon>
                <strong>{{wording.address}}</strong>
            </div>
            <span class="place content">{{pickCarContact.place}}</span>
        </div>
        <div class="address content" *ngIf="showAddress">
            <small>{{pickCarContact.address}}</small>
        </div>
        <div class="hoursOfOperations">
            <div class="title"
                 [title]="wording.hoursOfOperationDetail"
                 (click)="isShowHoursOfOperationDetail=!isShowHoursOfOperationDetail">
                <fa-icon *ngIf="isShowIcon" [icon]="iconHourGlassEnd"></fa-icon>
                <strong>{{wording.hoursOfOperation}}</strong>
            </div>
            <ng-container *ngIf="!isShowHoursOfOperationDetail">
                <div class="hoursOfOperation content"
                     *ngFor="let hoursOfOperationSimplified of pickCarContact.hoursOfOperationsSimplified;">
                    {{hoursOfOperationSimplified}}
                </div>
            </ng-container>
            <ng-container *ngIf="isShowHoursOfOperationDetail">
                <div class="hoursOfOperation content" *ngFor="let hoursOfOperation of pickCarContact.hoursOfOperations;">
                    {{hoursOfOperation}}
                </div>
            </ng-container>
        </div>
        <br>
        <div class="telephones">
            <div class="title">
                <fa-icon *ngIf="isShowIcon" [icon]="iconPhone"></fa-icon>
                <strong>{{wording.phone}}</strong>
            </div>
            <div class="telephone content" *ngFor="let phone of pickCarContact.phones;">
                {{phone}}
            </div>
        </div>
    `,
    styles: [`
        .title {
            padding-bottom: 0.25rem;
            display: flex;
        }
        .content {
            padding-left: 20px;
        }

        .title fa-icon {
            width : 20px;
        }
        .title strong {
            flex-grow: 1;
        }

        /*.telephone, .hoursOfOperation, .place, .address {*/
        /*    padding-left: 0.75rem;*/
        /*}*/

        .hoursOfOperations .title {
            cursor: pointer;
        }

        .first {
            margin-top: 2rem;
        }

        .address {
            margin-bottom: 1rem;
        }
        
    `]
})
export class PickCarContactComponent implements OnInit {
    @Input()
    public booking: CarModel;
    @Input()
    public type: 'pickup' | 'dropOff' = 'pickup';
    @Input()
    public isShowIcon: boolean = false;
    @Input()
    public showPlace: boolean = false;
    @Input()
    public showAddress: boolean = false;

    public readonly iconPhone: IconDefinition = faPhone;
    public readonly iconHourGlassEnd: IconDefinition = faClock;
    public readonly iconLocation: IconDefinition = faMapMarkerAlt;
    public readonly wording: WordingClass = new WordingClass();
    public pickCarContact: IPickCarContact;
    public isShowHoursOfOperationDetail = false;

    public ngOnInit(): void {
        this.initPickCarContact();
    }

    private initPickCarContact(): void {
        this.pickCarContact = {
            hoursOfOperationsSimplified: this.booking.dataList.station.getOpeningHoursByGroupSimplified(capitalizeFirstLetter(this.type)),
            hoursOfOperations: this.booking.dataList.station.getOpeningHoursByGroup(capitalizeFirstLetter(this.type)),
            phones: this.booking.dataList.station.telephones,
            place: this.booking.dataList.station.name,
            address: this.booking.dataList.station.address.full
        };
    }

}
